import { dimensionNamesByLanguage } from '../input/impacts';
import { ImpactLanguage } from '../input/types';
import { Dimension } from '../types';

export function friendlyDimensionName(dimension: Dimension, lang: ImpactLanguage = ImpactLanguage.en) {
  return dimensionNamesByLanguage[lang][dimension];
}
